module.exports = __webpack_public_path__ + "static/media/digital-menu-pricing.f8bac524.svg";